<!--班级空间导航条 Sag 2020-04-15-->
<template>
  <div class="its-container">
    <!--    <div class="its-crumbs">当前位置：<span>班级空间</span></div>-->
    <subject-tabs v-if="user&&user.userType=='TEACHER'&&subjects.length>0" :items="subjects" @tab-change="subjectChange"></subject-tabs>
    <div class="its-classroom-nav">
        <upload :btn="upload.btn" :upload="{apiURL: upload.baseUrl}" :format="format" ref="upload" :father-action="uploadAction" title="上传文件"
          @file-list="getUploadFileList" :selected-action="checkUpload" :upload-limit="uploadLimit" :file-limit="fileLimit">
          <i class="its-icon its-icon-shangchuan"></i>
        </upload>
      <div-upload v-if="upload.visible" :visible.sync="upload.visible" ref="divUpload" :list="list" :defaultProps="defaultProps"
       :treeData="treeData" :file="upload.file" @node-click="nodeAction" @submit="fatherAction" :defaultCheckedKeys="searchParams.fileId"
       @upload-complete-action="uploadDialogAction" :file-list="fileList" @remove-file="removeFile" @add-files="addFiles"
        @clear-file-list="clearFileList" :file-limit="fileLimit" :upload-limit="uploadLimit"></div-upload>
      <el-tooltip placement="bottom-start">
        <div slot="content">按住ctrl键选择多个文件可同时上传哦~</div>
        <button class="ts-base-btn ts-primary-btn plain marginRight10" @click="optionAction('upload')"><i class="its-icon its-icon-shangchuan"></i>上传文件</button>
      </el-tooltip>
      <button v-if="canCreate" class="ts-base-btn ts-primary-btn marginRight10" @click="optionAction('create')"><i class="its-icon its-icon-xinjian"></i>新建文件夹</button>
      <button class="ts-base-btn ts-primary-btn marginRight10" @click="optionAction('download')" v-if="false"><i class="its-icon its-icon-download"></i>下载</button>
      <button class="ts-base-btn ts-primary-btn marginRight10 delete" @click="optionAction('delete')" v-if="showMoreOption">删除</button>
      <button class="ts-base-btn ts-primary-btn marginRight10 move" @click="optionAction('move')" v-if="showMoreOption">移动到</button>
      <div class="its-right">
        <el-input placeholder="搜索文件" v-model="searchKey" size="small" class="its-input" @keyup.enter.native="searchFile">
          <i slot="suffix" class="el-input__icon cm-font el-icon-search" @click="searchFile"></i>
        </el-input>
      </div>
    </div>
  </div>
</template>
<script>
import { flashChecker } from '../../../../utils/screen'
import Upload from '../../../components/Upload'
import SubjectTabs from './SubjectTabs'
import { classSpaceApi } from '@/utils/api'
import DivUpload from './DivUpload'
export default {
  name: 'SearchNav',
  components: {
    Upload,
    SubjectTabs,
    DivUpload
  },
  props: {
    searchParams: {
      type: Object,
      default: function () {
        return {// 搜索条件
          fileId: "0",
          keyword: "",
          filePath: "0",
        }
      }
    },
    sortedBy: {
      type: String,
      default: 'table' // grid
    },
    showMoreOption: {
      // 是否显示更多操作
      type: Boolean,
      default: false
    },
    fatherAction: {
      type: Function,
      default: null
    },
    list: {
      type: Array,
      default: function () {
        return []
      }
    },
    treeData: {
      type: Array,
      default: function () {
        return []
      }
    },
    defaultProps: {
      type: Object,
      default: function () {
        return {
          children: 'children',
          label: 'label',
          isLeaf: 'isLeaf'
        }
      }
    }
  },
  data() {
    return {
      format:{
        limit: 10,
        size: 500 * 1024 * 1024,
        accept: 'doc,docx,xls,xlsx,ppt,pptx,pdf,mp4,rmvb,flv,avi,mp3,wav,jpg,png', // 'avi,rm,mp3,wav,mid,mpg,mp4,mpeg,wma,rmvb,wmv,flv,swf,asf,rar,zip,xls,xlsx,csv,doc,wps,docx,ppt,dps,pptx,pdf'
      },
      searchKey: '',
      upload: {
        visible: false,
        init: true,
        btn: { title: '上传文件', id: 'its-upload', className: 'its-hidden' },
        baseUrl: '/ibook',
        file: { percent: 0, status: 'start' } // 上传的文件
      },
      subjects: [],
      defaultCheckedKeys: 0,
      fileList: [], // 上传文件列表
      fileLimit: 10, // 可上传文件数量
      uploadLimit: 10, // 该用户允许上传的文件数量
      isFirstUpload: true, // 第一次上传
    }
  },
  computed: {
    user: function () {
      return this.$store.state.user
    },
    canCreate: function () {
      const filePath = this.searchParams.filePath.split('/')
      return filePath.length < 4
    }
  },
  methods: {
    subjectChange: function (data) {
      this.$emit('subject-change', { subject: data, subjects: this.subjects })
    },
    optionAction: function (type) {
      if (this.fatherAction) {
        this.fatherAction({ type: type })
      }
    },
    exChangeSort: function () {
      let sorted = 'table'
      if (this.sortedBy === 'table') {
        sorted = 'grid'
      } else {
        sorted = 'table'
      }
      if (this.fatherAction) {
        this.fatherAction({ type: 'sorted', sorted: sorted })
      }
    },
    searchFile: function () {
      if (this.fatherAction) {
        this.fatherAction({ type: 'search', searchKey: this.searchKey })
      }
    },
    checkUpload: function (action) {
      console.log('---file---check---', action, this.fileLimit)
      if (action.uploadNum > this.fileLimit) {
        this.$message.error('单次上传文件不能超过' + this.fileLimit + '个')
        return
      }
      
      // 校验上传文件（文件数量限制，班级资料无需限制）
      if (action.callback) {
        action.callback(action.fileList, action.uploadNum)
      }
    },
    uploadDialogAction: function (action) {
      if (action.type === 'cancel') {
        this.$refs.upload.uploader.stop()
        this.$refs.upload.uploader.removeFile(this.upload.file)
        this.$refs.upload.uploader.refresh()
        this.upload.visible = false
      } else {
        this.upload.visible = false
        let message = this.upload.file.sType === 'create' ? '新建成功' : '上传成功'
        this.$message.success(message)
      }
    },
    uploadAction: function (param) {
      if (param.type === 'progress') {
        this.upload.file = param.file
        this.upload.file.sType = 'upload'
        if (this.upload.visible === false) {
          this.upload.visible = true
          this.isFirstUpload = true
        }
      } else if (param.type === 'fileUploaded') {
        let file = param.result.body
        this.upload.file = file
        if (param.result.code === 'error') {
          this.$set(this.upload.file, 'statusName', 'error')
          let msg = param.result.msg ? param.result.msg : '文件上传错误'
          this.$message({ message: msg, type: 'error' })
          return
        }
      } else if (param.type === 'error') {
        let error = param.error
        let fileList = error.fileList
        if (fileList && fileList.length > 0) {
          let file = fileList[0]
          this.upload.file = file
          if ((!file.size || file.size === 0) && error.code === -600) {
            let result = flashChecker()
            if (result && result.noFlash) {
              this.tip.callback = function () {
                window.open(result.site, '_blank')
              }
              this.tip.message = result.tip
              this.tip.visible = true
              return
            }
          }
        }
        // this.$message({message: error.message, type: 'error'})
        if (this.fatherAction) {
          this.fatherAction({ type: 'upload-error', message: error.message })
        }
      } else if (param.type === 'upload-limit') {
        this.upload.visible = true
        const action = {fileList: [], uploadNum: 0}
        this.checkUpload(action)
        this.$message({ message: param.error.message, type: 'error', customClass: 'bk-message-zIndex' })
      }
      this.$set(this.upload.file, 'statusName', param.type)
      console.log('upload-file-success', this.upload)
    },
    getUploadFileList: function (fileList) {
      // 获取已选的上传文件列表
      this.fileList = fileList// JSON.parse(JSON.stringify(fileList))
      if (this.fileList.length > 0) {
        this.upload.visible = true
        this.isFirstUpload = true
      }
    },
    removeFile: function (item) {
      // 移除文件
      let newArr = []
      this.fileList.forEach(file => {
        if (file.id !== item.id) {
          newArr.push(file)
        }
      })
      // 更新可上传文件列表
      let params = {
        uploadNum: newArr.length
      }
      this.checkUpload(params)
      this.fileList = newArr // JSON.parse(JSON.stringify(newArr))
      this.$refs.upload.showFileList = newArr
    },
    addFiles: function () {
      // 继续上传文件
      document.getElementById(this.upload.btn.id).click()
    },
    clearFileList: function () {
      // 清空队列数据
      this.fileList = []
      this.$refs.upload.clearFileList()
      // this.uploadCatalogId = this.currentNode.id
    },
    openUpload: function () {
      let id = this.getUploaderId()
      document.getElementById(id).click()
    },
    getUploaderId: function () {
      let id = ''
      let nodeEles = document.getElementById('its-upload-container').childNodes
      nodeEles.forEach(node => {
        if (node.nodeName.toLowerCase() === 'div') {
          id = node.id
          id = id.replace('_container', '')
          let childNodes = node.childNodes
          if (childNodes.length > 0) {
            childNodes.forEach(n => {
              if (n.nodeName.toLowerCase() === 'form') {
                id = n.id
                id = id.replace('_form', '')
              }
            })
          }
        }
      })

      return id
    },
    getSubjects: function () {
      //获取任教科目列表
      classSpaceApi.getTeacherSubject().then(res => {
        if (res.success) {
          let result = res.body
          if (result && result.length > 0) {
            this.subject = JSON.parse(JSON.stringify(result[0]))
            this.subjects = result
            // this.getShareClassList()
            // this.getDataList()
          }
        } else {
          this.$message.error(res.message)
        }
      })
    },
    nodeAction: function (data) {
      this.$emit('node-click', data)
    }
  },
  watch: {
    user: {
      handler: function () {
        if (this.user && this.user.userType === 'TEACHER') {
          this.getSubjects()
        }
      },
      immediate: true,
      deep: true
    }
  }
}
</script>
<style >
#its-upload-container {
  display: none;
}
</style>
<style scoped>
.its-hidden {
  display: none;
}
.its-crumbs {
  line-height: 40px;
  color: #67778d;
  font-size: 13px;
}
.its-crumbs span {
  color: #333333;
}
.its-classroom-nav {
  padding: 0 15px;
  height: 60px;
  line-height: 60px;
  background: white;
}

.its-upload-btn-space {
  border: 1px solid #5591fe;
  background-color: #fff;
  padding-left: 5px;
  padding-right: 10px;
  vertical-align: middle;
  color: #1487e3;
}
.its-upload-btn-space:hover {
  background-color: #5591fe;
  color: white;
}
.its-right {
  float: right;
  width: 330px;
}

.its-right >>> .el-input__suffix {
  right: 4px;
  top: 1px;
}

.its-sorted-by {
  cursor: pointer;
  margin-left: 10px;
  vertical-align: middle;
}
.its-sorted-by:hover {
  color: #5591fe;
}
</style>
